import React, { useState } from 'react';
import { Box, Collapse, Divider, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

/**
 * AppFilters — bandeau de filtres repliable, à placer en tête d'un
 * `AppSurface padding={0}` juste avant le tableau. Fournit le titre
 * « Filtres », le bouton chevron, le repli et le filet de séparation.
 */
const AppFilters: React.FC<{ children: React.ReactNode; defaultOpen?: boolean }> = ({
  children,
  defaultOpen = true,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <>
      <Box sx={{ px: 2, pt: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
        <Typography
          sx={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.09em', textTransform: 'uppercase', color: '#667085' }}
        >
          Filtres
        </Typography>
        <IconButton size="small" onClick={() => setOpen((v) => !v)} aria-label="Afficher/masquer les filtres">
          <ExpandMoreIcon
            fontSize="small"
            sx={{ transition: 'transform .2s', transform: open ? 'rotate(180deg)' : 'none', color: '#667085' }}
          />
        </IconButton>
      </Box>
      <Collapse in={open} timeout="auto">
        {children}
      </Collapse>
      <Divider sx={{ borderColor: '#e4e7ec' }} />
    </>
  );
};

export default AppFilters;
